module.exports = __webpack_public_path__ + "amonkhet.jpg?c277df64a4ddc1900c3348d7b5b65249";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/amonkhet.jpg
// module id = 49
// module chunks = 0